import { useRecoilValue } from 'recoil';

import { useManageTeamConsultees } from 'api';
import {
  manageUsersFilterPermissionState,
  manageUsersFilterTeamState,
  manageUsersSearchState,
} from 'store';
import { ApplicationUser } from 'types';

export type useGetManageTeamConsulteeRecordsReturn = {
  userData: ApplicationUser[];
  totalCount: number;
};

export const useGetManageTeamConsulteeRecords = (): useGetManageTeamConsulteeRecordsReturn => {
  const { data: ApplicationUsers } = useManageTeamConsultees();
  const teamFilter = useRecoilValue(manageUsersFilterTeamState);
  const permissionFilter = useRecoilValue(manageUsersFilterPermissionState);
  const searchText = useRecoilValue(manageUsersSearchState);

  const users = ApplicationUsers?.consultees ?? [];
  const totalCount = users.length;

  const userData = users
    .filter((r) =>
      teamFilter === 0 ? r : r.teams.map((x) => x.value).includes(Number(teamFilter))
    )
    .filter((r) =>
      permissionFilter !== 0 && r.permission
        ? r.permission.value === Number(permissionFilter)
        : r
    )
    .filter(
      (r) =>
        !searchText ||
        r.name.toLowerCase().includes(searchText.toLowerCase()) ||
        r.email.toLowerCase().includes(searchText.toLowerCase())
    );

  return {
    userData,
    totalCount,
  };
};
